import ClientItem from 'owa-mail-store/lib/store/schema/ClientItem';
import getTableConversationRelation from '../utils/getTableConversationRelation';
import isItemView from '../utils/isItemView';
import { getListViewStore } from '../store/Store';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { mutatorAction } from 'satcheljs';

/**
 * Sets the shouldShowRSVP property value of an item/conversation
 * @param tableViewId id of the tableView where the item/conversation resides
 * @param rowId id of item/conversation
 * @param showRSVP value to set
 */
export const setShouldShowRSVP = mutatorAction(
    'setShouldShowRSVP',
    (tableViewId: string, rowId: string, showRSVP: boolean) => {
        const tableView = getListViewStore().tableViews.get(tableViewId);
        if (isItemView(tableView)) {
            const mailStoreItem = getMailStore().items.get(rowId);
            if (!mailStoreItem) {
                return;
            }
            (mailStoreItem as ClientItem).shouldShowRSVP = showRSVP;
        } else {
            const tableConversationRelation = getTableConversationRelation(rowId, tableViewId);
            if (!tableConversationRelation) {
                return;
            }
            tableConversationRelation.shouldShowRSVP = showRSVP;
        }
    }
);
